import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";
import DataScience from "@/Components/Front/SVGS/Services/DataScience";
import {Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import LineaData2 from "@/Components/Front/SVGS/LineaData2";
import ArrowBack from "@/Components/Front/SVGS/ArrowBack";
import Masonry from "react-masonry-css";
import Header from "@/Components/Front/Header";
import Corner from "@/Components/Front/SVGS/Corner";
import Gad from "@/Components/Front/PNGS/grad-registry.png";
import {useMediaQuery} from "react-responsive";
import ChevronRightAlt from "@/Components/Front/SVGS/ChevronRightAlt";

export default function ServicesDataScience(props) {

    const [lang, setLang] = useLang(props.locale);
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 1023px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})

    const [cards, setCards] = useState([
        {id: 1, color:"#F72585"},
        {id: 2, color:"#B5179E"},
        {id: 3, color:"#7209B7"},
        {id: 4, color:"#3F37C9"},
        {id: 5 , color:"#4361EE"},
        {id: 6, color:"#4895EF"},


    ])

    const textProps = {
        lang: lang, language: props.language,
    };


    return (
        <AppLayout {...props}>
            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang} activeItem={"services-data-science"}/>

            <section id="data-science" className={"services-page"}>
                {isMobileAndTabletPortrait &&
                    <>

                    <div className={"back-arrow"}>
                        <Link href={"/"}>
                        <ChevronRightAlt/>
                        </Link>
                    </div>

                    <div className={"mobile-image"}>
                        <img src="images/DataScienceSmall.svg" alt=""/>


                    </div>
                    </>
                }
                <div className="in-frame-inner">

                    {isLg &&
                    <>

                        {/*<div className={"section-gradient"}>*/}
                        {/*    <img src={Gad} alt=""/>*/}
                        {/*</div>*/}
                        <div className={"section-background"}>
                            <img src="images/DataScienceSmall.svg" alt=""/>

                            {/*<DataScience/>*/}
                        </div>

                    </>
                    }

                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaData2/>
                        </div>
                        <div className={"service-back-button"}>
                            <Link href={"/"}>
                                <ArrowBack/>
                            </Link>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"science-title-1"}/></span>
                            <span><Text {...textProps} str={"science-title-2"}/></span>
                        </h1>
                        <p>
                            <Text {...textProps} str={"science-text-1"} html={true}/>

                        </p>
                        <p>
                            <Text {...textProps} str={"science-text-2"} html={true}/>
                        </p>
                        <p>
                            <Text {...textProps} str={"science-text-3"} html={true}/>

                        </p>

                    </div>

                    <div className={"cards-container"}>
                        <Masonry
                            breakpointCols={isMobile ? 1 : 3 }
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column">
                            {/* array of JSX items */}

                        {cards.map((i) => {
                            return (
                                <article key={"card-" + i.id}>
                                    <Corner color={i.color}/>
                                    <div className={"el-count"}  ><span>
                                       {i.id}
                                    </span></div>

                                    <h1>
                                        <Text {...textProps} str={"science-card-" + i.id + "-title"} />

                                    </h1>
                                    <p>

                                        <Text {...textProps} str={"science-card-" + i.id + "-text"} html={true}/>
                                    </p>

                                </article>
                            )


                        })}
                        </Masonry>
                    </div>

                    <div className={"back-button"}>
                        <Link href={"/"}>

                            <button>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        </AppLayout>

    )
}
